import { Component, OnInit, Inject, Input } from '@angular/core';
import { CommonTalktousModalComponent } from '../../../common-talktous-modal/components/common-talktous-modal/common-talktous-modal.component';
import { VariablesService, EventsService, UtilService } from '../../../../shared/services';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-talk-to-us-btn',
  templateUrl: './talk-to-us-btn.component.html',
  styleUrls: ['./talk-to-us-btn.component.scss']
})
export class TalkToUsBtnComponent implements OnInit {
  @Input() width;
  @Input() height;
  @Input() info2;
  @Input() title = 'talk to us';
  @Input() buttonClass;
  @Input() config;

  constructor(
    public dialog: MatDialog,
    public variablesService: VariablesService,
    public eventService: EventsService,
    public utilService: UtilService
  ) { }

  ngOnInit() {
  }

  openDialogTalkToUs() {
    const payload = {
      eventName: 'talk_to_us',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      info_1: 'type',
      info_2: this.info2 || '',
    };
    this.eventService.sendSystemEvent(payload).subscribe(() => { });
    this.dialog.open(CommonTalktousModalComponent, {
      data: this.config,
      maxWidth: '100vw',
      width: '519px',
      panelClass: 'talk-to-us-modal'
    });
  }

}
